import times from 'lodash/times';
/**
 * Functional version of this that allows specifying the number of iterations
 * https://gist.github.com/blixt/f17b47c62508be59987b
 *
 * Creates a pseudo-random value generator. The seed must be an integer.
 * Uses an optimized version of the Park-Miller PRNG.
 * http://www.firstpr.com.au/dsp/rand31/
 */
export default (seed = new Date().getTime()) => {
  const _seed = seed % 2147483647;
  return i => {
    const random = times(i).reduce(random => (random * 16807) % 2147483647, _seed);
    return (random - 1) / 2147483646;
  };
};
